import React from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { PageListBean } from "../ds/client_ds.js";
import { CityBean, CitySearchCriteria, RestCityListRequest } from "../ds/ds.js";
import { DeleteIcon, DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  InputCheckbox,
  InputTextbox,
  ProgressBar,
  ShowError,
} from "../gui_components/UIComponents.js";
import { isEmpty, isEmptyArray } from "../gui_components/Util.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import {
  BaseInquiryPageListToolBar,
  BaseInquiryToolBar,
  BaseToolBar,
} from "../modules/BaseModule.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { MasterService } from "../services/MasterService.js";

class CityListForm extends React.Component {
  constructor(props) {
    super(props);
    this.listFormCodeRef = React.createRef();
  }
  componentDidMount() {}
  componentDidUpdate() {
    this.setInputFocus();
  }
  setInputFocus() {
    if (this.listFormCodeRef.current != null) {
      this.listFormCodeRef.current.focus();
    }
  }
  enterKeyEventHandler = (e) => {
    this.props.enterKeyEventHandler(e);
  };
  clickGoButton = (e) => {
    if (e.detail === 1) this.props.clickGoButton(e);
  };
  editCity = (e, val, countryCode, stateCode) => {
    if (e.detail === 1) this.props.editCity(val, countryCode, stateCode);
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  deleteCity = (e, val, rowData) => {
    if (e.detail === 1) this.props.deleteCity(val, rowData);
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail === 1) this.props.handleSortingChange(accessor);
  };
  render() {
    let city_list = this.props.city_list;
    return (
      <div>
        <div>
          <Row>
            <Col sm="2">
              <FormLabel id="searchBarLabel">City</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                ref={this.listFormCodeRef}
                enterKeyEventHandler={this.props.enterKeyEventHandler}
                name="code"
                onChange={this.props.onChange}
                value={this.props.cityData.code}
                style={{ "text-transform": "uppercase" }}
                isMandatory={true}
              ></InputTextbox>
            </Col>
            <Col sm="1">
              <Button
                id="fabric_Add_Button"
                className="text-center"
                onClick={(e) => this.clickGoButton(e)}
              >
                Go
              </Button>
            </Col>
          </Row>
        </div>

        <div className="div_default">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th onClick={(e) => this.handleSortingChange(e, "code")}>
                  Code
                  {this.props.order === "desc" &&
                  this.props.sortField === "code" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "description")}>
                  Name
                  {this.props.order === "desc" &&
                  this.props.sortField === "description" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "companyCode")}>
                  CompanyCode
                  {this.props.order === "desc" &&
                  this.props.sortField === "companyCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "isActive")}>
                  Active
                  {this.props.order === "desc" &&
                  this.props.sortField === "isActive" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                {/* <th>Remove</th> */}
              </tr>
            </thead>
            {city_list != null ? (
              <tbody>
                {city_list.map((ln, index) => (
                  <tr key={index}>
                    <td>
                      <Button
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) =>
                          this.editCity(
                            e,
                            ln.code,
                            ln.countryCode,
                            ln.stateCode
                          )
                        }
                      >
                        {ln.code}
                      </Button>
                    </td>
                    <td>{ln.description}</td>
                    <td>{ln.companyCode}</td>
                    <td>{ln.isActive}</td>
                    {/* <td className="text-right">
                      <Button
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) => this.deleteCity(e, ln.code, ln)}
                      >
                        <DeleteIcon />
                      </Button>
                    </td> */}
                  </tr>
                ))}
              </tbody>
            ) : null}
          </Table>
          {city_list.length != 0 ? null : (
            <div className="no_Data">{"NO DATA"}</div>
          )}
        </div>
      </div>
    );
  }
}
class CityEntryForm extends React.Component {
  constructor(props) {
    super(props);
    this.codeRef = React.createRef();
  }
  componentDidMount() {
    this.setInputFocus();
  }
  setInputFocus() {
    if (this.codeRef.current != null) {
      this.codeRef.current.focus();
    }
  }
  onChange = (e) => {
    this.props.onChange(e);
  };
  render() {
    let cityData = this.props.cityData;
    let isDisableFields = this.props.isDisableFields;
    return (
      <div>
        <Row>
          <Col sm="1">
            {" "}
            <FormLabel>Company</FormLabel>{" "}
          </Col>
          <Col sm="3">
            {" "}
            <InputTextbox
              type="text"
              name="companyCode"
              onChange={this.onChange}
              value={cityData.companyCode}
              disabled={true}
            />{" "}
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>Code </FormLabel>{" "}
          </Col>
          <Col sm="3">
            {" "}
            <InputTextbox
              name="code"
              type="text"
              placeholder="Enter Code"
              onChange={this.onChange}
              value={cityData.code}
              style={{ "text-transform": "uppercase" }}
              disabled={isDisableFields}
              ref={this.codeRef}
              isMandatory={true}
            />{" "}
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>Name</FormLabel>{" "}
          </Col>
          <Col sm="3">
            {" "}
            <InputTextbox
              name="description"
              type="text"
              placeholder="Enter Name"
              onChange={this.onChange}
              value={cityData.description}
              style={{ "text-transform": "uppercase" }}
              isMandatory={true}
            />{" "}
          </Col>
        </Row>
        <Row>
          <Col sm="1">
            {" "}
            <FormLabel>Country Code</FormLabel>{" "}
          </Col>
          <Col sm="3">
            {" "}
            <InputTextbox
              onChange={this.props.onCountryChange}
              name="countryCode"
              placeholder="countryCode"
              value={cityData.countryCode}
              lookupRequired={true}
              lookupHandler={this.props.countryLookupHandler}
              enterKeyEventHandler={this.props.countryCodeEnterKeyEvent}
              autoCompleteListData={
                this.props.countryCodePageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={
                this.props.displayAutoCompleteCountryCodeList
              }
              showAutoCompleteList={this.props.showAutoCompleteCountryCodeList}
              isMandatory={true}
            />
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>State</FormLabel>{" "}
          </Col>
          <Col sm="3">
            {" "}
            <InputTextbox
              onChange={this.props.onStateChange}
              name="stateCode"
              value={cityData.stateCode}
              lookupRequired={true}
              lookupHandler={this.props.stateLookupHandler}
              enterKeyEventHandler={this.props.stateEnterKeyEvent}
              autoCompleteListData={this.props.statePageListForAutoCompleteList}
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={this.props.displayAutoCompleteStateList}
              showAutoCompleteList={this.props.showAutoCompleteStateList}
              style={{ "text-transform": "uppercase" }}
              isMandatory={true}
            />
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>Active</FormLabel>{" "}
          </Col>
          <Col sm="3">
            {" "}
            <InputCheckbox
              name="isActive"
              onChange={this.onChange}
              type="checkbox"
              checked={cityData.isActive}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

class CityList extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      city_list: [],
      pageTitle: "City",
      cityData: new CityBean(),
      pageList: new PageListBean(),
      criteria: new CitySearchCriteria(),
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowBackButton: false,
      error_list: [],
      currentPageNumber: 0,
      totalCount: 0,
      isListFormOpen: true,
      isEntryFormOpen: false,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      isShowExitButton: true,
      progressLoadingText: "",
      isShowProgressBarPopup: false,
      isDisableFields: false,
      states: new Array(),
      showAutoCompleteStateList: false,
      statePageListForAutoCompleteList: new Array(),
      stateLookupHandler: null,
      countries: new Array(),
      countryLookupHandler: null,
      showAutoCompleteCountryCodeList: true,
      countryCodePageListForAutoCompleteList: new Array(),
      order: "asc",
      sortField: "",
    };
    this.moduleCaption = "City";
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    const { cache } = appData;
    this.cache = cache;
    let cityData = new CityBean();
    cityData.companyCode = this.companyCode;
    this.loadPage(1);
    this.setState({
      cityData: cityData,
    });
    this.fetchAttributeCache();
    this.initLookupHandlers();
  }
  fetchAttributeCache = () => {
    const attribute_cache = { ...this.cache };
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    let states = this.state.states;
    let countries = this.state.countries;
    if (attribute_cache.states != null || attribute_cache.states != undefined) {
      states = attribute_cache.states;
    }
    if (
      attribute_cache.countries != null ||
      attribute_cache.countries != undefined
    ) {
      countries = attribute_cache.countries;
    }
    this.state.states = states;
    this.state.countries = countries;
    this.setState({
      states: states,
      countries: countries,
    });
  };
  initLookupHandlers = () => {
    let stateLookupHandler = new GenericAttributeLookupHandler(
      this.state.states,
      "State"
    );
    this.setState({
      stateLookupHandler: stateLookupHandler,
    });
    let countryLookupHandler = new GenericAttributeLookupHandler(
      this.state.countries,
      "Country"
    );
    this.setState({ countryLookupHandler: countryLookupHandler });
  };
  handleresponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = this.state.error_list;
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  moduleExit = () => {
    this.props.onModuleExit();
  };
  onChange = (e) => {
    let cityData = this.state.cityData;
    cityData[e.target.name] = e.target.value;
    this.setState({
      cityData: cityData,
    });
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };
  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };
  loadPage = (pageNumber) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let pageList = this.state.pageList;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;
    this.loadCityPage(criteria, pageInput);
  };

  save = () => {
    this.saveCity();
  };
  back = () => {
    this.clearError();
    this.cleardata();
    this.hideAlertCallBack(false);
    this.closeEntryForm();
  };
  cleardata = () => {
    let cityData = new CityBean();
    cityData.companyCode = this.companyCode;
    this.setState({
      cityData: cityData,
    });
  };
  clickGoButton = () => {
    let cityCode = this.state.cityData.code;

    let cityIdvalue = cityCode.toUpperCase();
    let cityList = this.state.city_list.filter(
      (cityBean) => cityBean.code == cityIdvalue
    );
    let cityObject = null;
    if (cityList !== null) {
      cityObject = cityList[0];
    }

    if (!isEmptyArray(cityObject)) {
      this.editCity_go(
        cityObject.code,
        cityObject.countryCode,
        cityObject.stateCode
      );
    } else {
      this.openEntryForm();
    }
  };
  openEntryForm = () => {
    this.setState({
      isListFormOpen: false,
      isPageListToolBar: false,
      isLoadFirstButton: false,
      isLoadLastButton: false,
      isLoadPreviousButton: false,
      isLoadNextButton: false,
      isEntryFormOpen: true,
      isShowSaveButton: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowBackButton: true,
      isShowAlert: false,
    });
  };
  closeEntryForm = () => {
    this.clearError();
    let pageTitle = this.moduleCaption;
    this.setState({
      isListFormOpen: true,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isEntryFormOpen: false,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowBackButton: false,
      isShowClearErrorButton: false,
      pageTitle: pageTitle,
      isDisableFields: false,
    });
    this.loadPage(1);
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed });
  };
  errorCallBack = (error) => {
    ShowError("Error : " + error);
  };
  enterKeyEventHandler = (e) => {
    e.preventDefault();
    setTimeout(() => {
      this.clickGoButton();
    }, 200);
  };
  loadPageResponse = (response) => {
    if (response.data != null && response.data.cityPageList) {
      let city_list = [];
      if (!isEmptyArray(response.data.cityPageList.cities)) {
        city_list = response.data.cityPageList.cities;
        city_list.map((Info) => {
          if (Info.isActive == true) {
            Info.isActive = "True";
          } else {
            Info.isActive = "False";
          }
        });
        let pageList = this.state.pageList;
        pageList.currentPage = response.data.cityPageList.currentPage;
        pageList.pageSize = response.data.cityPageList.pageSize;
        pageList.totalCount = response.data.cityPageList.totalCount;
        this.setState({
          pageList: pageList,
        });
      }
      this.setState({
        city_list: city_list,
      });
    }
  };
  loadCityPage = (criteria, pageList) => {
    let requestInput = new RestCityListRequest();
    requestInput.searchCriteria = criteria;
    requestInput.pageInput = pageList;
    if (SecurityAccessManager.CityMaintenanceView_IsAccessible()) {
      MasterService.getCityPageList(
        requestInput,
        this.loadPageResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadSaveResponse = (response) => {
    this.handleresponse(response.data);
    this.loadPage(1);
    this.cleardata();
    this.closeEntryForm();
  };
  saveCity = () => {
    let input = this.state.cityData;
    if (input.isFetched == true) {
      if (SecurityAccessManager.CityMaintenanceEdit_IsAccessible()) {
        MasterService.updateCity(
          input,
          this.loadSaveResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    } else {
      if (SecurityAccessManager.CityMaintenanceCreate_IsAccessible()) {
        MasterService.createCity(
          input,
          this.loadSaveResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  loadEditResponse = (response) => {
    if (response.data != null) {
      if (!isEmptyArray(response.data.cityBean)) {
        let cityData = response.data.cityBean;
        this.setState({
          cityData: cityData,
        });
        this.disable();
      }
    }
    this.openEntryForm();
  };
  editCity_go = (code, countryCode, stateCode) => {
    let readrestInput = new CitySearchCriteria();
    readrestInput.companyCode = this.companyCode;
    readrestInput.countryCode = countryCode;
    readrestInput.stateCode = stateCode;
    readrestInput.code = code;
    if (SecurityAccessManager.CityMaintenanceView_IsAccessible()) {
      MasterService.readCity(
        readrestInput,
        this.loadEditResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "View Access Denied";
      let errList = this.state.error_list;
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  editCity = (code, countryCode, stateCode) => {
    let readRequest = new CitySearchCriteria();
    readRequest.companyCode = this.companyCode;
    readRequest.code = code;
    readRequest.countryCode = countryCode;
    readRequest.stateCode = stateCode;
    if (SecurityAccessManager.CityMaintenanceView_IsAccessible()) {
      MasterService.readCity(
        readRequest,
        this.loadEditResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  onStateChange = (e) => {
    let stateCode = e.target.value;
    this.state.showAutoCompleteStateList = true;
    let temp_data = this.state.cityData;
    let showAutoCompleteList = this.state.showAutoCompleteStateList;
    if (isEmpty(stateCode)) {
      this.state.showAutoCompleteStateList = false;
      let showAutoCompleteList = this.state.showAutoCompleteStateList;
      let stateData = this.state.cityData;
      stateData.stateCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteStateList: showAutoCompleteList,
        cityData: stateData,
        statePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && stateCode !== "") {
      this.readstateBySearchString(stateCode);
    }
    temp_data["stateCode"] = e.target.value;
    this.setState({ cityData: temp_data });
  };
  readstateBySearchString(searchString) {
    let stateData = this.state.states;
    let simpleAutoCompleteList = new Array();
    if (stateData.length > 0 && stateData != null) {
      stateData.map((state) => {
        let simpleItemBean = {
          code: state.code,
          description: state.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (state) => state.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      statePageListForAutoCompleteList: filteredSuggestions,
    });
  }
  stateEnterKeyEvent = (e) => {
    let temp_data = this.state.cityData;
    temp_data["stateCode"] = e.target.value;
    let state_List = this.state.states;
    let stateBean = null;
    state_List.map((state) => {
      if (state.code == e.target.value) {
        stateBean = state;
      }
    });
    if (!isEmpty(stateBean)) {
      let temp_data = this.state.cityData;
      temp_data.stateCode = stateBean.code;
      this.setState({
        cityData: temp_data,
        statePageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteStateList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteStateList: showAutoCompleteList });
  };
  onCountryChange = (e) => {
    let countrycode = e.target.value;
    this.state.showAutoCompleteCountryCodeList = true;
    let cityData = this.state.cityData;
    let showAutoCompleteList = this.state.showAutoCompleteCountryCodeList;
    if (isEmpty(countrycode)) {
      this.state.showAutoCompleteCountryCodeList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCountryCodeList;
      let cityData = this.state.cityData;
      cityData.countrycode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteCountryCodeList: showAutoCompleteList,
        cityData: cityData,
        countryCodePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && countrycode !== "") {
      this.readcountryCodeBySearchString(countrycode);
    }
    cityData["countryCode"] = e.target.value;
    this.setState({ cityData: cityData });
  };
  readcountryCodeBySearchString(searchString) {
    let countryData = this.state.countries;
    let simpleAutoCompleteList = new Array();
    if (countryData.length > 0 && countryData != null) {
      countryData.map((countryDatas) => {
        let simpleItemBean = {
          code: countryDatas.code,
          description: countryDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletecountryLists) =>
        simpleAutoCompletecountryLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      countryCodePageListForAutoCompleteList: filteredSuggestions,
    });
  }
  countryCodeEnterKeyEvent = (e) => {
    let cityData = this.state.cityData;
    cityData["countryCode"] = e.target.value;
    let country_List = this.state.countries;
    let countryBean = null;
    country_List.map((countrycode) => {
      if (countrycode.code == e.target.value) {
        countryBean = countrycode;
      }
    });
    if (!isEmpty(countryBean)) {
      let cityData = this.state.cityData;
      cityData.countryCode = countryBean.code;

      this.setState({
        cityData: cityData,
        countryCodePageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteCountryCodeList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCountryCodeList: showAutoCompleteList });
  };
  deleteCity = (code, rowData) => {
    //
  };

  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let list = this.state.city_list;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ city_list: sorted });
    }
  };
  render() {
    let pageList = this.state.pageList;
    let totalPages = 0;
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    let currentPage = pageList.currentPage;
    return (
      <div>
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <ProgressBar
          closeAlertModalCallBack={this.closeAlertProgressBarModalCallBack}
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        {this.state.isPageListToolBar && (
          <BaseInquiryPageListToolBar
            currentPage={currentPage}
            totalPages={totalPages}
            isLoadFirstButton={this.state.isLoadFirstButton}
            isLoadLastButton={this.state.isLoadLastButton}
            isLoadPreviousButton={this.state.isLoadPreviousButton}
            isLoadNextButton={this.state.isLoadNextButton}
            loadFirst={this.loadFirst}
            loadLast={this.loadLast}
            loadNext={this.loadNext}
            loadPrevious={this.loadPrevious}
          />
        )}
        {this.state.isListFormOpen && (
          <BaseInquiryToolBar
            onModuleExit={() => this.moduleExit()}
            pageTitle={this.state.pageTitle}
            isShowExitButton={this.state.isShowExitButton}
          />
        )}

        {!this.state.isListFormOpen && (
          <BaseToolBar
            back={this.back}
            save={this.save}
            clearError={this.clearError}
            isShowSaveButton={this.state.isShowSaveButton}
            isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
            isShowClearErrorButton={this.state.isShowClearErrorButton}
            isShowBackButton={this.state.isShowBackButton}
            pageTitle={this.state.pageTitle}
          />
        )}
        {this.state.isListFormOpen && (
          <CityListForm
            {...this.state}
            clickGoButton={this.clickGoButton}
            editCity={this.editCity}
            enterKeyEventHandler={this.enterKeyEventHandler}
            onChange={this.onChange}
            deleteCity={this.deleteCity}
            handleSortingChange={this.handleSortingChange}
          />
        )}
        {this.state.isEntryFormOpen && (
          <CityEntryForm
            {...this.state}
            onChange={this.onChange}
            onCountryChange={this.onCountryChange}
            countryCodeEnterKeyEvent={this.countryCodeEnterKeyEvent}
            displayAutoCompleteCountryCodeList={
              this.displayAutoCompleteCountryCodeList
            }
            onStateChange={this.onStateChange}
            stateEnterKeyEvent={this.stateEnterKeyEvent}
            displayAutoCompleteStateList={this.displayAutoCompleteStateList}
          />
        )}
      </div>
    );
  }
}

function CityAttributeModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="app">
        <CityList {...props} name="" />
        <br />
      </div>
    </div>
  );
}
export default CityAttributeModule;
